import type { PaletteInput } from './types';

export function parsePaletteInput(raw: string): PaletteInput {
  if (raw === '') {
    return { mode: 'empty', args: [], activeArgIndex: 0, activeToken: '', query: '' };
  }
  const first = raw[0];
  if (first === '/') {
    const rest = raw.slice(1);
    const spaceIdx = rest.indexOf(' ');
    if (spaceIdx < 0) {
      return {
        mode: 'command',
        args: [],
        activeArgIndex: 0,
        activeToken: rest,
        query: rest,
      };
    }
    const commandSlash = rest.slice(0, spaceIdx);
    const argsStr = rest.slice(spaceIdx + 1);
    const args = argsStr === '' ? [''] : argsStr.split(' ');
    return {
      mode: 'command',
      commandSlash,
      args,
      activeArgIndex: args.length - 1,
      activeToken: args[args.length - 1],
      query: argsStr,
    };
  }
  if (first === '#') {
    // `#` matches the markdown heading prefix: typing `#title` filters the
    // active doc's headings the same way a heading line starts with `#`.
    return { mode: 'outline', args: [], activeArgIndex: 0, activeToken: raw.slice(1), query: raw.slice(1) };
  }
  if (first === '?') {
    return { mode: 'help', args: [], activeArgIndex: 0, activeToken: raw.slice(1), query: raw.slice(1) };
  }
  return { mode: 'mixed', args: [], activeArgIndex: 0, activeToken: raw, query: raw };
}
